import React, { Fragment, useEffect, useMemo } from 'react'
import { Box, Button } from '@material-ui/core'

import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'
import useGovernanceProjectNameDpo from 'hooks/useGovernanceProjectNameDpo'

import { CheckCircle as CheckIcon } from 'react-feather'

import { Container, LoadingFeedback, Page } from 'components'
import { HeaderTitle } from './components'
import { StepComponents } from './Steppers'

import useStyles from './styles'
import helpers from 'helpers'

const NameDpo = () => {
  const styles = useStyles()

  const { steps, setSteps, currentStep, setCurrentStep } =
    useJourneyWhiteLabel()

  const {
    loading,
    governanceProjectTemplate,
    loadGovernanceProjectTemplate,
    recaptcha,
  } = useGovernanceProjectNameDpo()

  useEffect(() => {
    loadGovernanceProjectTemplate()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!!governanceProjectTemplate && steps.length === 0) {
      setSteps(
        helpers.governanceProject.mountDpoSteps(governanceProjectTemplate),
      )
    }
    // eslint-disable-next-line
  }, [loading, governanceProjectTemplate])

  const [isFirstStep, isLastStep, CurrentComponent] = useMemo(
    () => [
      currentStep === 0,
      currentStep === steps.length - 1,
      StepComponents?.[currentStep] ?? Fragment,
    ],

    //eslint-disable-next-line
    [currentStep],
  )

  const isAttachNominationStep = currentStep === StepComponents.length - 1

  const handleBack = () => {
    if (!isFirstStep) {
      setCurrentStep((prevStep) => prevStep - 1)
    }
  }

  const EndComponent = () => (
    <Box className={styles.boxFinish}>
      <CheckIcon size="20vh" color="#80B92B" />
    </Box>
  )

  return (
    <Page
      className={styles.root}
      title={`Nomeie o DPO - ${governanceProjectTemplate?.name}`}
    >
      <LoadingFeedback open={!governanceProjectTemplate && loading} />
      <Container maxWidth="md" spacingSm={2}>
        <HeaderTitle />
        {isLastStep ? (
          <EndComponent />
        ) : (
          <>
            <CurrentComponent />
            <Box
              className={styles.boxButtons}
              display="flex"
              width="100%"
              justifyContent={isFirstStep ? 'center' : 'flex-end'}
              mt={isFirstStep ? 1 : 4}
            >
              {!isFirstStep && (
                <Button onClick={handleBack} variant="outlined" color="primary">
                  Voltar
                </Button>
              )}
              <Button
                type="submit"
                form="name-dpo-form"
                variant="contained"
                color="primary"
                disabled={loading || (isAttachNominationStep && !recaptcha)}
              >
                {isFirstStep ? 'Iniciar' : 'Avançar'}
              </Button>
            </Box>
          </>
        )}
      </Container>
    </Page>
  )
}

export default NameDpo
